import { Form, FormCheckProps } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useMemo } from "react";
import { BaseInputProps, ErrorMessage } from ".";
import { usePermissions } from "../../../contexts";
import { getDisplayedAccessor, getFormError } from "../../../helper-functions";

interface CheckboxProps extends FormCheckProps, BaseInputProps {}

export function Checkbox({
    accessor,
    id,
    viewClaim,
    editClaim,
    readOnly,
    className,
    suppressMargin,
    title,
    "aria-label": ariaLabel,
    ...rest
}: CheckboxProps) {
    const {
        register,
        formState: { errors },
    } = useFormContext();
    const { hasPermission } = usePermissions();
    const error = useMemo(() => getFormError(errors, accessor), [errors, accessor]);

    const isReadOnly = useMemo(
        () => (editClaim ? !hasPermission(editClaim) : readOnly),
        [readOnly, editClaim, hasPermission]
    );

    if (!!viewClaim && !hasPermission(viewClaim)) return null;

    return (
        <>
            <Form.Check
                type="checkbox"
                id={id ?? accessor}
                className={`${!suppressMargin && "mb-2"} ${className}`}
                readOnly={isReadOnly}
                aria-readonly={isReadOnly}
                aria-label={ariaLabel ?? rest.label?.toString()}
                title={title ?? getDisplayedAccessor(accessor)}
                {...rest}
                {...register(accessor)}
            />
            <ErrorMessage error={error} />
        </>
    );
}
